// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.panel-body {
    padding: 0;
    background-color: transparent;
}

.panel {
    border: none;
}

.panel-footer {
    padding: 0
}

.control-label {
    font-weight: normal;
}

.rct-title {
    font-size: 12px;
}

.navbar-text {
    margin: 8px;
}

.navbar {
    background: rgb(48, 48, 48);
    border: none;
}

.navbar-nav > li {
    height: 100%;
}

.navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:focus, .navbar-default .navbar-nav > .open > a:hover {
    background-color: transparent;
    color: white;
}

.dropdown-menu > li > a {
    font-weight: normal;
    color: #eee;
}

.dropdown-menu {
    background-color: rgba(0, 63, 96, 0.95);
}

.rct-title {
    font-size: 13px;
    font-weight: normal;
}

.rct-icon {
    font-size: 13px;
    font-weight: normal;
}

html {
    height: 100%;
}

body {
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
    background-color: white;
    height: 100%;
}

.navbar-header {
    background-color: transparent;
    height: 79px;
    width: auto;
    margin-right: 0;
}

.navbar-brand {
    height: 100%;
    padding: 14px 0 0;
    background-color: transparent;
}

.navbar-collapse {
    padding-left: 0;
}


.footer {
    height: 40px;
    padding: 8px 4px 4px 10px;
}

#root {
    height: 100%;
}

[data-reactroot] {
    height: 100%;
}

@keyframes spinner {
    0% {
        transform: rotate(0deg) scale(1)
    }
    50% {
        transform: rotate(180deg) scale(0.8)
    }
    100% {
        transform: rotate(360deg) scale(1)
    }
}

.no-select {
    -webkit-touch-callout: none; /* iOS Safari */
    -webkit-user-select: none; /* Safari */
    -khtml-user-select: none; /* Konqueror HTML */
    -moz-user-select: none; /* Firefox */
    -ms-user-select: none; /* Internet Explorer/Edge */
    user-select: none;
    /* Non-prefixed version, currently
                                     supported by Chrome and Opera */
}

.navbar-toggle {
    margin-top: 25px;
    margin-right: 40px;
}

#tutorial_modal {
    text-align: center;
    border: none;
    background-color: transparent;
}

#tutorial_modal > div {
    width: 1000px;
    height: auto;
    padding: 0;
    margin: 20px auto auto;
    border: none;
    background-color: transparent;
}

#tutorial_modal > div > div {
    width: auto;
    margin: auto;
    padding: 0;
    border: none;
    background-color: transparent;
}

#tutorial_modal > div > div > div {
    padding: 0;
    border: none;
    background-color: transparent;
}

video#tutorial {
    width: 1000px;
    height: auto;
}

#nav-examples {
    margin-right: 30px;
}

#tutorial-nav {
    margin-right: 30px;
}

ul.navbar-right {
    padding-left: 0;
}

@media only screen and (max-width: 1050px) {
    #janelia {
        visibility: collapse;
        width: 0;
        height: 0;
        margin: 0;
    }

    .navbar-right {
        padding-left: 20px;
        padding-top: 0;
    }

    #nav-examples {
        margin-right: 0;
    }

    #tutorial-nav {
        margin-right: 0;
    }
}

@media only screen and (max-width: 769px) {
    .navbar-right {
        padding-left: 20px;
        padding-top: 0;
    }
    .navbar-collapse {
        padding-left: 40px;
    }
}
`, "",{"version":3,"sources":["webpack://./util/override.css"],"names":[],"mappings":"AAAA;IACI,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;AACJ;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,uDAAuD;IACvD,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI;QACI;IACJ;IACA;QACI;IACJ;IACA;QACI;IACJ;AACJ;;AAEA;IACI,2BAA2B,EAAE,eAAe;IAC5C,yBAAyB,EAAE,WAAW;IACtC,wBAAwB,EAAE,mBAAmB;IAC7C,sBAAsB,EAAE,YAAY;IACpC,qBAAqB,EAAE,2BAA2B;IAClD,iBAAiB;IACjB;oEACgE;AACpE;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,sBAAsB;IACtB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,oBAAoB;QACpB,QAAQ;QACR,SAAS;QACT,SAAS;IACb;;IAEA;QACI,kBAAkB;QAClB,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,kBAAkB;QAClB,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".panel-body {\n    padding: 0;\n    background-color: transparent;\n}\n\n.panel {\n    border: none;\n}\n\n.panel-footer {\n    padding: 0\n}\n\n.control-label {\n    font-weight: normal;\n}\n\n.rct-title {\n    font-size: 12px;\n}\n\n.navbar-text {\n    margin: 8px;\n}\n\n.navbar {\n    background: rgb(48, 48, 48);\n    border: none;\n}\n\n.navbar-nav > li {\n    height: 100%;\n}\n\n.navbar-default .navbar-nav > .open > a, .navbar-default .navbar-nav > .open > a:focus, .navbar-default .navbar-nav > .open > a:hover {\n    background-color: transparent;\n    color: white;\n}\n\n.dropdown-menu > li > a {\n    font-weight: normal;\n    color: #eee;\n}\n\n.dropdown-menu {\n    background-color: rgba(0, 63, 96, 0.95);\n}\n\n.rct-title {\n    font-size: 13px;\n    font-weight: normal;\n}\n\n.rct-icon {\n    font-size: 13px;\n    font-weight: normal;\n}\n\nhtml {\n    height: 100%;\n}\n\nbody {\n    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;\n    background-color: white;\n    height: 100%;\n}\n\n.navbar-header {\n    background-color: transparent;\n    height: 79px;\n    width: auto;\n    margin-right: 0;\n}\n\n.navbar-brand {\n    height: 100%;\n    padding: 14px 0 0;\n    background-color: transparent;\n}\n\n.navbar-collapse {\n    padding-left: 0;\n}\n\n\n.footer {\n    height: 40px;\n    padding: 8px 4px 4px 10px;\n}\n\n#root {\n    height: 100%;\n}\n\n[data-reactroot] {\n    height: 100%;\n}\n\n@keyframes spinner {\n    0% {\n        transform: rotate(0deg) scale(1)\n    }\n    50% {\n        transform: rotate(180deg) scale(0.8)\n    }\n    100% {\n        transform: rotate(360deg) scale(1)\n    }\n}\n\n.no-select {\n    -webkit-touch-callout: none; /* iOS Safari */\n    -webkit-user-select: none; /* Safari */\n    -khtml-user-select: none; /* Konqueror HTML */\n    -moz-user-select: none; /* Firefox */\n    -ms-user-select: none; /* Internet Explorer/Edge */\n    user-select: none;\n    /* Non-prefixed version, currently\n                                     supported by Chrome and Opera */\n}\n\n.navbar-toggle {\n    margin-top: 25px;\n    margin-right: 40px;\n}\n\n#tutorial_modal {\n    text-align: center;\n    border: none;\n    background-color: transparent;\n}\n\n#tutorial_modal > div {\n    width: 1000px;\n    height: auto;\n    padding: 0;\n    margin: 20px auto auto;\n    border: none;\n    background-color: transparent;\n}\n\n#tutorial_modal > div > div {\n    width: auto;\n    margin: auto;\n    padding: 0;\n    border: none;\n    background-color: transparent;\n}\n\n#tutorial_modal > div > div > div {\n    padding: 0;\n    border: none;\n    background-color: transparent;\n}\n\nvideo#tutorial {\n    width: 1000px;\n    height: auto;\n}\n\n#nav-examples {\n    margin-right: 30px;\n}\n\n#tutorial-nav {\n    margin-right: 30px;\n}\n\nul.navbar-right {\n    padding-left: 0;\n}\n\n@media only screen and (max-width: 1050px) {\n    #janelia {\n        visibility: collapse;\n        width: 0;\n        height: 0;\n        margin: 0;\n    }\n\n    .navbar-right {\n        padding-left: 20px;\n        padding-top: 0;\n    }\n\n    #nav-examples {\n        margin-right: 0;\n    }\n\n    #tutorial-nav {\n        margin-right: 0;\n    }\n}\n\n@media only screen and (max-width: 769px) {\n    .navbar-right {\n        padding-left: 20px;\n        padding-top: 0;\n    }\n    .navbar-collapse {\n        padding-left: 40px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
